<template>
  <div>
    <div
      v-loading="mainLoader"
      element-loading-background="rgba(255, 255, 255, 1)"
    >
      <el-row class="py-3">
        <el-col
          :xs="12"
          :sm="12"
        >
          <h2 class="py-0">
            Members
          </h2>
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
        >
          <div
            class="font-weight-bold button-link pull-right pt-1"
            @click="invitationDialogVisible = true"
          >
            Invite Members
          </div>
        </el-col>
      </el-row>
      <mini-member-card
        v-for="(member, index) in listMembers"
        :key="index"
        :member="member"
        :is-owner="user.id == member.id"
        :show-remove="true"
        @remove-member="onRemoveMember"
      />
    </div>
    <member-invitation-dialog
      :visible="invitationDialogVisible"
      @close="invitationDialogVisible = false"
      @member-invited="fetchMembers()"
    />

    <confirm-remove-member-dialog
      v-if="memberToRemove && user.organisation"
      :member="memberToRemove"
      :organisation="user.organisation"
      :visible="removeMemberDialogVisible"
      @close="removeMemberDialogVisible = false"
      @member-removed="onMemberRemoved"
    />
  </div>
</template>
<script>
import gsApi from "@/services/gs.api";
import MiniMemberCard from "@/components/platform/members/mini-member-card";
import MemberInvitationDialog from "@/components/platform/organisations/member-invitation-dialog";
import ConfirmRemoveMemberDialog from "@/components/platform/organisations/confirm-remove-member-dialog";
import { mapGetters } from "vuex";
export default {
  components: {
    MiniMemberCard,
    MemberInvitationDialog,
    ConfirmRemoveMemberDialog
  },
  data() {
    return {
      mainLoader: false,
      listMembers: [],
      invitationDialogVisible: false,
      removeMemberDialogVisible: false,
      memberToRemove: null
    };
  },
  computed: {
    ...mapGetters(["user"])
  },
  created() {
    this.fetchMembers();
  },
  
  methods: {
    fetchMembers() {
      this.mainLoader = true;

      gsApi.organisation
        .members(this.user.organisation.id)
        .then(response => {
          this.listMembers = response.data?.data
        })
        .catch(response => {
          if (response.status == 422) {
            let firstError =
                response.data.errors[Object.keys(response.data.errors)[0]];
            this.$alert(firstError[0], "Error", {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            });
          } else {
            this.$alert(
              "Sorry, your request could not be processed",
              `Error ${error.response.data.error.status_code} - ${error.response.data.error.message}`,
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal"
              }
            );
          }
        })
        .finally(() => {
          this.mainLoader = false;
        });
    },
    onRemoveMember(member){
      this.memberToRemove = member;
      this.removeMemberDialogVisible = true
    },
    onMemberRemoved(id){
      
      let index = this.listMembers.findIndex(x => x.id == id);

      if (index>= 0) {
        this.$delete(this.listMembers, index);
      }
      this.removeMemberDialogVisible = false
    }
  },

};
</script>
  